var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataSources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.5 8V4.5c0-.831 0-1.247-.175-1.503a1 1 0 0 0-.657-.42c-.306-.052-.683.122-1.438.47L5.358 7.143c-.673.31-1.01.466-1.257.707a2 2 0 0 0-.487.76c-.115.326-.115.697-.115 1.438V15m13.5-.5h.01M3.5 11.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C5.02 21 5.58 21 6.7 21h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108v-6.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.98 8 19.42 8 18.3 8H6.7c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3.5 9.52 3.5 10.08 3.5 11.2Zm14 3.3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSources);
export default __webpack_public_path__ + "static/media/dataSources.752c84e75b50977f544592ae500e9956.svg";
export { ForwardRef as ReactComponent };